
import SearchItems from "@/components/SearchItems.vue";
import { http } from "@/config/httpCommon";
import myMixins from "@/mixins/myMixins";
import { uniq } from "lodash";
import Vue from "vue";
import Delete from "vue-material-design-icons/Delete.vue";
import Key from "vue-material-design-icons/Key.vue";
import Edit from "vue-material-design-icons/Pencil.vue";
import { validationMixin } from "vuelidate";

import { santaClone } from "@/helpers/Helpers";
import { Coupons, ProductWithPrice, SubscriptionRequest } from "@/interfaces/ProductWithPrice";
import { StripeConfigConstants, StripeCustomer } from "@/interfaces/Stripe";
import { Company } from "@/interfaces/company";
import { LabelCodePair, LabelValuePair, Pagination } from "@/interfaces/general";
import { PriceList } from "@/interfaces/priceList";
import { StripeInvoiceTemplate } from "@/interfaces/stripeInvoiceTemplate";
import editCompanyModal from "./editCompanyModal.vue";

export default Vue.extend({
  name: "Companies",
  mixins: [myMixins, validationMixin],
  components: {
    // ValidationProvider,
    Delete,
    SearchItems,
    Key,
    Edit,
    editCompanyModal,
  },
  async created() {
    this.$store.commit("set", ["showLoader", false]);
    await this.$store.dispatch("countries");
    this.countries = this.$store.getters.getCountries;
  },
  mounted() {
    this.getCompanies();
    this.getStripeInvoiceTemplates();
    this.getStripeCustomers();
  },
  data() {
    return {
      companies: [] as Company[],
      showLoader: false,
      inactive_message: "",
      opened_via_switch: false,
      active_company: null,
      company_headers: [
        { key: "company_name", label: "Name" },
        { key: "integration", label: "Integration" },
        { key: "subscription", label: "Subscription" },
        { key: "priceList", label: "Price List" },
        { key: "country", label: "Country" },
        { key: "user", label: "Contact Person" },
        { key: "override_due_payment", label: "Override Due Payment" },
        { key: "pending_payment", label: "Pending Payment" },
        { key: "is_active", label: "Is Active" },
        { key: "actions", label: "Actions" },
      ],
      filters: {},
      current_company_id: null,
      pagination: {
        rows: null,
        currentPage: null,
        perPage: null,
        total: 0,
      },
      priceList: {},

      overrideMerchant: 0,
      pricelist_id: "",
      company_country_id: "",
      billing_country_id: "",
      activeCompany: null as Company | null,
      beforeUpdateCompany: null as Company | null,
      countries: [] as (LabelCodePair & { id: number })[],
      stripeConfigConstants: {
        integration: [] as LabelValuePair[],
        stripePaymentType: [] as LabelValuePair[],
        stripeTaxCode: [] as LabelValuePair[],
      } as StripeConfigConstants,
      priceLists: [] as PriceList[],
      defaultPriceList: null as PriceList | null,
      stripeInvoiceTemplates: [] as StripeInvoiceTemplate[],
      stripeCanadianInvoiceTemplates: [] as StripeInvoiceTemplate[],
      stripeDefaultInvoiceTemplates: [] as StripeInvoiceTemplate[],
      stripeCanadianCustomers: [] as StripeCustomer[],
      stripeDefaultCustomers: [] as StripeCustomer[],
      stripePricesListing: [] as ProductWithPrice[],
      stripeCoupons: [] as Coupons[],
      selectedCoupon: null as Coupons | null,
      selectedPrice: null as ProductWithPrice | null,
      trialStates: {},
      trialDays: {},
      gracePeriod: null,
    }
  },
  filters: {
    capitalize: function (data) {
      let capitalized = [];
      if (data) {
        data.split(" ").forEach((word) => {
          capitalized.push(word.charAt(0).toUpperCase() + word.slice(1).toLowerCase());
        });
      }
      return capitalized.join(" ");
    },
    normalize: function (val: number) {
      return val / 100;
    }
  },
  methods: {
    async setFilters(values = {}, query_params = true) {
      let filters_default_obj = {
        search: this.filters.search ? this.filters.search : "",
        page: 1,
      };
      this.filters = { ...filters_default_obj, ...values };
    },
    getPriceLists() {
      http.get('/pricelists').then((response) => {
        this.priceLists = response.data.result.pricelists as PriceList[];
        this.defaultPriceList = this.priceLists.find((priceList: PriceList) => priceList.is_default);
      }).catch((errorResponse) => {
        this.handleResponseErrors(errorResponse);
      });

    },
    getCompanies(params = null) {
      this.showLoader = true;
      let url = "companies";
      const query_string = new URLSearchParams(this.filters).toString();
      if (query_string) {
        url += `?${query_string}`;
      }
      http
        .get(url)
        .then((successResponse) => {
          const response_data = successResponse.data;
          if (response_data.success) {
            this.companies = response_data.result.companies.data as Company[];
            this.stripeConfigConstants = response_data.result.stripeConfigConstants as StripeConfigConstants;
            this.priceLists = response_data.result.priceLists as PriceList[];
            this.showLoader = false;
            this.makePagination(response_data.result.companies);
          } else {
            this.showServerErrors(successResponse);
          }
        })
        .catch((errorResponse) => {
          this.showError(errorResponse);
        });
    },

    async getStripePrices(company_id, update) {
      this.showLoader = true;
      let url = `stripe/prices-product?company_id=${company_id}`;
      await http
        .get(url)
        .then((successResponse) => {
          if (successResponse.status === 200) {
            const response_data = successResponse.data;
            this.stripePricesListing = response_data.result.prices_product as ProductWithPrice[];
            this.stripeCoupons = response_data.result.coupons as Coupons[];

            // Clear previous trial states
            this.trialStates = {};
            this.trialDays = {};

            if (update) {
              this.selectedPrice = this.stripePricesListing.find(x => x.id === this.active_company?.subscription_details?.price_id);
              this.selectedCoupon = this.stripeCoupons.find((coupon) => coupon.id === this.active_company?.subscription_details?.stripe_coupon_id);
              if (this.selectedPrice) {
                const currentTrialDays = this.active_company?.subscription_details?.trial_days;
                this.trialDays = { [this.selectedPrice.id]: currentTrialDays };
                this.trialStates = { [this.selectedPrice.id]: currentTrialDays ? true : false };
              }

              this.gracePeriod = this.active_company?.subscription_details?.subscription_grace_days;
            } else {
              this.selectedPrice = null;
              this.selectedCoupon = null;
              this.gracePeriod = null;
            }

            this.showLoader = false;
            this.handleModalAction('price-list-modal');
          }
        })
        .catch((errorResponse) => {
          this.showError(errorResponse);
        });
      this.showLoader = false;
    },
    async subsccribeToStripe() {
      let url = this.active_company?.subscription_details?.id ? 'stripe/update-subscription-details' : 'stripe/add-subscription-details';
      let payload: SubscriptionRequest = {
        company_id: this.active_company?.id,
        plan_name: this.selectedPrice?.product?.name,
        plan_description: this.selectedPrice?.product?.description,
        plan_images: null,
        pricing_type: this.selectedPrice?.type,
        amount: this.selectedPrice?.unit_amount / 100,
        currency: this.selectedPrice?.currency,
        billing_period: this.selectedPrice?.recurring?.interval,
        custom_interval_days: this.selectedPrice?.recurring?.interval_count,
        trial_days: this.trialDays[this.selectedPrice?.id],
        stripe_coupon_id: this.selectedCoupon?.id,
        coupon_type: this.selectedCoupon?.percent_off ? 'percentage' : 'fixed',
        discount: this.selectedCoupon?.percent_off ? this.selectedCoupon?.percent_off : this.selectedCoupon?.amount_off,
        apply_to_specific_products: true,
        coupon_duration: this.selectedCoupon?.duration,
        coupon_start_date: null,
        coupon_end_date: null,
        coupon_max_redemptions: this.selectedCoupon?.max_redemptions,
        coupon_use_customer_facing_code: true,
        coupon_customer_facing_code: "basic-subscription",
        price_id: this.selectedPrice?.id,
        subscription_grace_days: this.gracePeriod,
      }
      this.showLoader = true;

      await http[this.active_company?.subscription_details?.id ? 'put' : 'post'](url, payload)
        .then((successResponse) => {
        })
        .catch((errorResponse) => {
          this.showError(errorResponse);
        }).finally(() => {
          this.showLoader = false;
          this.handleModalAction('price-list-modal', 'hide');
          this.getCompanies();
        });
    },
    async cancelSubscription(company_id: number, subscription_id: string, immediate: boolean) {
      this.showLoader = true;
      let url = immediate ? 'stripe/cancel-subscription-now' : 'stripe/cancel-subscription-at-end';
      let payload = {
        company_id: company_id,
        subscription_id: subscription_id
      }
      await http.post(url, payload)
        .then(() => {
        })
        .catch((errorResponse) => {
          this.showError(errorResponse);
        }).finally(() => {
          setTimeout(()=>{
            this.showLoader = false;
            this.getCompanies();
          },2000)
        });
    },
    async handlePagination(page = "") {
      this.setFilters({ page: page });
      this.getCompanies();
    },
    closeMessage(company_id, inactive_message, status) {
      if (this.opened_via_switch) {
        this.inactive_message = "";
        this.updateStatus(company_id, inactive_message, status);
      } else {
        this.inactive_message = "";
      }
      this.opened_via_switch = false;
    },
    setMessage(company_id, inactive_message, status) {
      this.opened_via_switch = true;
      if (status) {
        inactive_message = "";
        this.updateStatus(company_id, inactive_message, status);
      } else {
        this.inactive_message = company_id;
      }
    },
    updateStatus(company_id, inactive_message, status) {
      status = status ? 1 : 0;
      inactive_message =
        inactive_message == undefined ||
          inactive_message == null ||
          inactive_message == "undefined" ||
          inactive_message == "null"
          ? ""
          : inactive_message;
      const data = new FormData();
      data.append("company_id", company_id);
      data.append("inactive_message", inactive_message);
      data.append("status", status);

      if (company_id != "") {
        http
          .post("company/updateStatus", data)
          .then((successResponse) => {
            if (successResponse.data.success) {
              this.getCompanies();
              this.showToast("Status updated successfully!", "SUCCESS");
            }
          })
          .catch((errorResponse) => {
            this.showError(errorResponse);
          });
      } else {
        this.showToast("Company doesn't exist!", "DANGER");
      }

      this.inactive_message = "";
    },
    showCompanyFactories(company_index) {
      this.active_company = JSON.parse(JSON.stringify(this.companies[company_index]));
      this.active_company["company_index"] = company_index;
      this.handleModalAction("factories-modal");
    },
    async showPricesModal(company_index, update) {
      this.active_company = JSON.parse(JSON.stringify(this.companies[company_index]));
      this.active_company["company_index"] = company_index;
      await this.getStripePrices(this.active_company.id, update);
    },

    handleModalAction(name, action = "show") {
      this.$bvModal[action](name);
    },
    toggleAllProductsSelection(factory, action = "select_all"): void {
      const value = action == "select_all" ? true : false;
      factory.products.forEach((product) => {
        product.selected = value;
      });
      factory.selected = value;
      if (action == "select_all") {
        factory.selected_products_count = factory.total_products;
      } else {
        factory.selected_products_count = 0;
      }
    },
    handleProductSelection(updated_val, factory) {
      if (updated_val) {
        //if not selected products count is zero then it means all products are selected
        factory.selected =
          factory.products.filter((product) => !product.selected).length == 0;
        ++factory.selected_products_count;
      } else {
        factory.selected = false;
        --factory.selected_products_count;
      }
    },
    assignProductsToCompany() {
      const { id: company_id, factories } = this.active_company;
      let company_products = [];
      let factory_ids = [];
      factories.forEach((factory) => {
        factory.products
          .filter((product) => product.selected)
          .forEach((product) => {
            company_products.push({
              company_id,
              product_id: product.id,
              sort_order: product.sort_order,
              published: product.published,
              display_name: product.display_name,
            });
            //somehow in backend the factory id="shareable" becomes 0 in backend method addShareableFactory() that's why added if condition
            if (factory.id > 0) {
              factory_ids.push(factory.id);
            }
          });
      });
      factory_ids = uniq(factory_ids);
      let data = {
        company_products,
        company_id,
        factory_ids,
      };
      http
        .post("assign_products/to/company", data)
        .then((successResponse) => {
          this.active_company = null;
          this.getCompanies();
        })
        .catch((errorResponse) => {
          this.showError(errorResponse);
        });
    },
    async searchCompanies() {
      await this.setFilters({ page: 1 });
      this.getCompanies();
    },
    editCompany(company) {
      this.beforeUpdateCompany = santaClone(company);
      this.activeCompany = company;
      this.$nextTick(() => {
        this.$bvModal.show("company-edit-modal");
      });
    },
    getCompanyIntegration(item) {
      if (item.platform === "wordpress") {
        return "Wordpress";
      } else if (item.platform === "shopify") {
        return "Shopify";
      } else if (item.platform === "cdnExceptLogin" || item.platform === "self") {
        return "Standalone";
      } else if (item.platform === null) {
        return "No Integrations";
      }
    },

    overrideDuePayment(company) {
      this.showLoader = true;
      http
        .put(`companies/toggle-override-due-payment/${company.id}`, {
          override_due_payment: company.override_due_payment,
        })
        .then((successResponse) => {
          const response_data = successResponse.data;
          if (response_data.success) {
            this.companies = response_data.result.companies.data;
            this.showToast("Override Due Payment successfully updated", "SUCCESS");
            this.showLoader = false;
            this.makePagination(response_data.result.companies);
          } else {
            this.showLoader = false;
            this.showToast("Something went wrong", "ERROR");
            this.showServerErrors(successResponse);
          }
        })
        .catch((errorResponse) => {
          this.showLoader = false;
          this.showToast("Something went wrong", "ERROR");
          this.showError(errorResponse);
        });
    },
    updatePendingPayment(company) {
      this.showLoader = true;
      http
        .put(`companies/toggle-pending-payment/${company.id}`, {
          pending_payment: company.pending_payment,
        })
        .then((successResponse) => {
          const response_data = successResponse.data;
          if (response_data.success) {
            this.companies = response_data.result.companies.data;
            this.showToast("Pending Payment successfully updated", "SUCCESS");
            this.showLoader = false;
            this.makePagination(response_data.result.companies as Pagination);
          } else {
            this.showLoader = false;
            this.showToast("Something went wrong", "ERROR");
            this.showServerErrors(successResponse);
          }
        })
        .catch((errorResponse) => {
          this.showLoader = false;
          this.showToast("Something went wrong", "ERROR");
          this.showError(errorResponse);
        });
    },
    handleCompanyUpdated(updatedCompany) {
      this.getCompanies();
      this.showToast("Company updated successfully", "SUCCESS");
      this.$bvModal.hide("company-edit-modal");
      this.activeCompany = null;
      this.beforeUpdateCompany = null;
    },
    handleCompanyUpdateCanceled() {
      this.activeCompany = null;
      this.companies = this.companies.map(company => company.id === this.beforeUpdateCompany.id ? this.beforeUpdateCompany : company);
      this.beforeUpdateCompany = null;
    },
    getStripeInvoiceTemplates() {
      http.post('/get-stripe-invoice-templates').then(res => {
        this.stripeCanadianInvoiceTemplates = res.data.result.stripeCanadianInvoicesTemplates;
        this.stripeDefaultInvoiceTemplates = res.data.result.stripeDefaultInvoicesTemplates;
      }).catch((errorResponse) => {
        this.handleResponseErrors(errorResponse);
      });
    },
    getStripeCustomers() {
      http.post('/get-stripe-customers').then(res => {
        const response_result = res.data.result;
        this.stripeCanadianCustomers = response_result.stripeCanadianCustomers;
        this.stripeDefaultCustomers = response_result.stripeDefaultCustomers;
      }).catch((errorResponse) => {
        this.handleResponseErrors(errorResponse);
      });
    },
    // handlePriceChange(){

    // }
  },
  watch: {
    // Optional: cleanup trialDays if unchecked
    trialStates: {
      handler(newVal) {
        for (const id in newVal) {
          if (!newVal[id]) this.trialDays[id] = '';
        }
      },
    },
    selectedPrice(newPrice, oldPrice) {
      if (newPrice !== oldPrice && oldPrice !== null) {

        this.trialStates = {};
        this.trialDays = {};

        if (newPrice) {
          this.$set(this.trialStates, newPrice.id);
        }
      }
    }
  },
});
